import { BrandCampaign } from "../../../../shared/models/brandCampaign";
import { BrandCampaignCalendar } from "../../../../shared/models/brandCampaignCalendar";
import { BrandCalendarPost } from "../../../../shared/models/brandCampaignCalendarPost";
import { BrandCampaignDetails } from "../../../../shared/models/brandCampaignDetail";

export class BrandCampaignContentCalendarPostEditDialogData {
  constructor(
    public readonly post: BrandCalendarPost,
    public readonly brandId: number,
    public readonly campaign: BrandCampaign,
    public readonly campaignDetails: BrandCampaignDetails,
    public readonly campaignCalendar: BrandCampaignCalendar,
  ) {}
}
